import Live from '.';
import { RouteType } from '@/lib/route';

const LiveRoutes: RouteType = {
  path: '/live/:tenantId/:elearningId/:type/:frameId?',
  component: Live,
};

export interface LiveParamType {
  tenantId: string;
  elearningId: string;
  type: 'live';
  themeId: string;
  frameId: string;
}

export default LiveRoutes;
